<template>
  <div class="center">
    <banner title="产品中心" />
    <div class="center-section" v-loading="loading">
      <div class="center-section-content br-top-no">
        <div class="filtering-list-flex">
        	<div class="filtering-list-title">{{ filtering.title }}</div>
        	<div class="filtering-list-item" :style="{ height: filtering.isMore ? 'auto' : '50px' }">
        		<span class="span" :class="v.id === category ? 'dd-active' : ''" v-for="(v, k) in filtering.children" :key="k" @click="onSelItem(filtering, v)">{{
        			v.label
        		}}</span>
        		<div class="dd-more" v-if="filtering.isShowMore" @click="filtering.isMore = !filtering.isMore">
        			<span>{{ filtering.isMore ? '收起' : '展开' }}</span>
        			<i :class="filtering.isMore ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
        		</div>
        	</div>
        </div>

		<div class="flex-warp" v-if="filterList.length > 0">
			<el-row :gutter="15" style="width: 100%;">
				<el-col :span="8" style="margin-bottom: 15px;" v-for="(v, k) in filterList" :key="k" @click.native="onTableItemClick(v)">
					<div class="flex-warp-item">
						<div class="flex-warp-item-box">
							<div class="item-img">
								<img :src="v.cover" />
							</div>
							<div class="item-txt">
								<div class="item-txt-title">{{ v.title }}</div>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<div v-else class="filtering-no-data">
			<div class="no-data-box">
				<i class="el-icon-search"></i>
				<span class="no-txt">暂无数据</span>
			</div>
		</div>

		<div style="margin:15px auto;">
			<el-pagination
			  style="text-align: center;"
			  :current-page="pageInfo.curPage"
			  :page-sizes="[9, 18, 27]"
			  :page-size="pageInfo.pageSize"
			  background
			  layout="total, sizes, prev, pager, next, jumper"
			  :total="pageInfo.total"
			  @size-change="handleSizeChange"
			  @current-change="handleCurrentChange"
			/>
		</div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "productCenter",
  components: {
    Banner
  },
  data() {
    return {
      loading: false,
	  pageInfo: {
	    curPage: 1,
	    pageSize: 9,
	    total: 100
	  },
	  filterList : [],
	  filtering: {
		title: '产品',
		isShowMore: true,
		isMore: false,
		id: 0,
		children: [
			{
				id: '',
				label: '全部',
			}
		],
	  },
	  category:''
    };
  },
  methods: {
	  // 过滤当前选中的数据
	  onSelItem(val, v){
	  	this.category = v.id
	  	this.pageInfo.curPage = 1
	  	this.getListByPage()
	  },
	  onTableItemClick(item){
		this.$router.push({
		 	name: 'centerdetails',
		 	params: {
		 		id: item.id,
		 	}
		})
	  },
	  limitLength(data){
	  	if (!data) {
	  		return ''
	  	}
		if(data.length>30){
			return data.slice(0,30)+"..."
		}else{
			return data
		}
	  },
	  async initPage(){
		await this.getAllList()
		this.getListByPage()
	  },
	  async getAllList(){
		  var ids = []
		await this.$http.post('/oa/newcms/category/getChildById',{parentId:"957341a8-e33a-4311-b28b-b209d2202b5b"})
		.then(response => {
			this.newstypeList = response.data.result
			response.data.result.forEach(item=>{
				var obj = {
					id: '',
					label: ''
				}
				obj.id = item.id
				obj.label = item.name
				ids.push(item.id)
				this.filtering.children.push(obj)
			})
			this.filtering.children[0].id = ids.join(",")
			this.category = ids.join(",")
			// console.log(response)
		})
		.catch(error=> {

		})
	  },
	  getListByPage(){
		var curPage = this.pageInfo.curPage
		var pageSize = this.pageInfo.pageSize
		var category = this.category
		this.loading = true
		// console.log(this.$qs.stringify({curPage,pageSize,category}))
		this.$http.post('/oa/newcms/article/getListByPage',{curPage,pageSize,category})
		.then(response => {
			this.newsList = response.data.result.data
			this.filterList = response.data.result.data
			this.pageInfo.total = Number(response.data.result.total)
			// console.log(response)
			// console.log(this.newsList)
			this.loading = false
		})
		.catch(error=> {

		})
	},
    handleSizeChange(val) {
		this.pageInfo.pageSize = val
		this.pageInfo.curPage = 1
		this.getListByPage()
    },
    handleCurrentChange(val) {
		this.pageInfo.curPage = val
		this.getListByPage()
    }
  },
  mounted() {
	this.initPage()
  },
  watch: {

  }
};
</script>

<style lang="scss" scoped>
	.center-section-content{
		width: 1240px;
		margin: auto;
	}
	.filtering-list-flex {
		margin: 20px 0px;
		&:last-of-type {
			.filtering-list-item {
				border-bottom: none !important;
			}
		}
		.filtering-list-title {
			float: left;
			width: 64px;
			font-weight: 700;
			position: relative;
			color: #666;
			margin: 15px 0;
			&:after {
				content: '';
				position: absolute;
				border: 1px solid #909399;
				border-width: 0 1px 1px 0;
				width: 4px;
				height: 4px;
				transform: rotate(-45deg) translateY(-50%);
				right: 10px;
				top: 50%;
			}
		}
		.filtering-list-item {
			border-bottom: 1px dotted #e0e0e0;
			margin-left: 64px;
			overflow: hidden;
			position: relative;
			.span {
				color: #8d8d91;
				font-size: 16px;
				float: left;
				padding: 0 15px;
				margin: 15px 0;
				&:hover {
					color: #409EFF;
					cursor: pointer;
				}
			}
			.dd-active {
				color: #409EFF;
			}
			.dd-more {
				font-size: 18px;
				position: absolute;
				right: 0;
				top: 16px;
				color: #8d8d91;
				&:hover {
					cursor: pointer;
					color: #409EFF;
				}
			}
		}
	}
	.br-top-no {
		border-top: none;
		.flex-warp {
			display: flex;
			flex-wrap: wrap;
			align-content: flex-start;
			margin-top: 15px;
			margin-bottom: 15px;
			.flex-warp-item {
				padding: 5px;
				width: 100%;
				height: 270px;
				.flex-warp-item-box {
					border: 1px solid #ebeef5;
					width: 100%;
					height: 100%;
					border-radius: 2px;
					display: flex;
					flex-direction: column;
					transition: all 0.3s ease;
					&:hover {
						cursor: pointer;
						border: 1px solid #409EFF;
						transition: all 0.3s ease;
						box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.03);
						.item-txt-title {
							color: #409EFF !important;
							transition: all 0.3s ease;
						}
						.item-img {
							img {
								transition: all 0.3s ease;
								transform: translateZ(0) scale(1.05);
							}
						}
					}
					.item-img {
						width: 100%;
						height: 215px;
						overflow: hidden;
						img {
							transition: all 0.3s ease;
							width: 100%;
							height: 100%;
						}
					}
					.item-txt {
						flex: 1;
						padding: 15px;
						display: flex;
						flex-direction: column;
						overflow: hidden;
						.item-txt-title {
							text-overflow: ellipsis;
							overflow: hidden;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							display: -webkit-box;
							color: #666666;
							transition: all 0.3s ease;
							&:hover {
								color: #409EFF;
								text-decoration: underline;
								transition: all 0.3s ease;
							}
						}
					}
				}
			}
		}
	}
	.filtering-no-data {
		display: flex;
		height: 100%;
		.no-data-box {
			color: #cccccc;
			margin: auto;
			height: 500px;
			line-height: 500px;
			i {
				font-size: 48px;
				vertical-align: middle;
			}
			.no-txt {
				font-size: 34px;
				text-align: center;
				margin-top: 15px;
				vertical-align: middle;
			}
		}
	}
</style>
